import { onboardingQueryKeys as e } from "../onboarding/useOnboardingQueryKeys.mjs";
import { verificationQueryKeys as t } from "./useVerificationQueryKeys.mjs";
import { useMutation as n, useQueryClient as r } from "@maat/store-hooks";
import { verificationApi as i } from "@maat/api-main";
//#region src/verification/useSubmitBusinessVerificationMutation.ts
var a = () => {
	let a = r();
	return n({
		mutationFn: i.submitBusinessVerification,
		onSuccess: () => {
			a.invalidateQueries({ queryKey: t.business() }), a.invalidateQueries({ queryKey: e.status() });
		}
	});
};
//#endregion
export { a as useSubmitBusinessVerificationMutation };
